import { BaseItem } from '@kirvanobr/aria-utils';

// src/base/menu-item-base.tsx
var MenuItemBase = BaseItem;
var menu_item_base_default = MenuItemBase;

export { menu_item_base_default };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-MNAJE7QR.mjs.map